import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Router, RouterLink } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from '../api-service.service';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';

@Component({
  selector: 'app-dealer-fota',
  templateUrl: './dealer-fota.component.html',
  styleUrls: ['./dealer-fota.component.scss'],
  standalone: true,
  imports: [
    RouterLink,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    MatIcon,
    MatTooltip,
    CommonSearchComponent,
    CommonPaginationComponent,
  ],
})
export class DealerFotaComponent implements OnInit {
  page = 1;
  size = 10;
  search = '';
  totalCount = 0;
  dealerFota = [];
  dealerFOTAForm: FormGroup = this.formBuilder.group({});
  userPermission = [];
  DealerFotaCreate = false;
  DealerFotaView = false;
  exportData = [];
  isDownloading = false;

  private storageListener = (event: StorageEvent) => {
    if (event.key === 'downloadInProgress') {
      this.isDownloading = event.newValue === 'true';
    }
  };
  constructor(
    public apiMicroservice: ApiServiceService,
    private formBuilder: FormBuilder,
    public router: Router,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.setDealerFotaLogForm();
    this.checkPermission();
    this.syncInitialDownloadState();
    if (this.DealerFotaView) {
      this.fetchDealerFota();
    }
  }

  syncInitialDownloadState() {
    // sync initial download state across tabs
    this.isDownloading = localStorage.getItem('downloadInProgress') === 'true';
    window.addEventListener('storage', this.storageListener);
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (element.pageName === 'Dealer FOTA' && element.view === false) {
          this.navigateBack();
        }
        if (element.pageName === 'Dealer FOTA' && element.view === true) {
          this.DealerFotaView = true;
        }
        if (element.pageName === 'Dealer FOTA' && element.create === true) {
          this.DealerFotaCreate = true;
        }
      }
    );
  }

  setDealerFotaLogForm() {
    this.dealerFOTAForm = this.formBuilder.group({
      modelListSearch: new FormControl(''),
    });
  }

  fetchDealerFota() {
    this.spinner.show();
    this.dealerFota = [];
    this.search = this.dealerFOTAForm.get('modelListSearch')?.value;
    this.apiMicroservice
      .getDelaerFotaData(this.page, this.size, this.search)
      .subscribe((res) => {
        this.dealerFota = res.data.map((item) => ({
          ...item, // Spread the existing properties
          createdAt: new Date(item.createdAt).toLocaleString('en-GB', {
            timeZone: 'Asia/Kolkata',
            hour12: true,
          }), // Convert `createdAt`
        }));
        this.totalCount = res.count;
        this.apiMicroservice.openSnackbar('Fetched Successfully');
        this.spinner.hide();
      });
  }

  onSearch(event: string) {
    this.page = 1;
    this.search = event;
    this.dealerFOTAForm
      ?.get('modelListSearch')
      ?.setValue(this.search ? this.search : '');
    this.fetchDealerFota();
  }

  onPageChange(event: number) {
    this.page = event;
    this.fetchDealerFota();
  }

  onSizeChange(event: number) {
    this.page = 1;
    this.size = event;
    this.fetchDealerFota();
  }

  // exportToExcelData() {
  //   if (confirm('Are you sure?')) {
  //     this.spinner.show();
  //     this.exportData = [];
  //     this.search = this.dealerFOTAForm.get('modelListSearch')?.value;
  //     this.apiMicroservice
  //       .getDelaerFotaData(this.page, this.totalCount, this.search)
  //       .subscribe((res) => {
  //         this.exportData = res.data;
  //         exportAsCsvFile(this.exportData, 'Dealer_Fota_');
  //         this.apiMicroservice.openSnackbar('File Ready For Download.');
  //         this.spinner.hide();
  //       });
  //   }
  // }

  downloadDealerFotaReport() {
    if (confirm('Are you sure?')) {
      // mark download in-progress and notify other tabs
      this.isDownloading = true;
      localStorage.setItem('downloadInProgress', 'true');

      this.apiMicroservice.openSnackbar(
        'Your file is being generated. Refreshing the page or logging out may interrupt the download.'
      );
      this.search = this.dealerFOTAForm?.get('modelListSearch')?.value;
      this.apiMicroservice.downloadDealerFotaReport(this.search).subscribe({
        next: (res) => {
          try {
            if (res?.status && res.fileDownloadUrl) {
              const link = document.createElement('a');
              link.href = res.fileDownloadUrl;
              link.download = ''; // let browser infer filename
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.apiMicroservice.openSnackbar('File ready for download');
            } else {
              this.apiMicroservice.openSnackbar(
                res?.message || 'File URL not available'
              );
            }
          } finally {
            // clear in-progress state
            this.isDownloading = false;
            localStorage.setItem('downloadInProgress', 'false');
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          const example =
            ERROR.error.message ||
            'Download failed. Please contact server team.';
          this.apiMicroservice.openSnackbar(example);
          // clear in-progress state
          this.isDownloading = false;
          localStorage.setItem('downloadInProgress', 'false');
        },
      });
    }
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
